import actions from './areaActions';
import mutations from './areaMutations';
import getters from './areaGetters';

const state = {
  items: []
};

export default {
  namespaced: true,
  state,
  mutations: mutations,
  getters: getters,
  actions: actions
}



// WEBPACK FOOTER //
// ./client/store/modules/area/index.js